import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-banner-secretaria-trabajo',
    templateUrl: './banner-secretaria-trabajo.component.html',
    styleUrls: ['./banner-secretaria-trabajo.component.scss'],
    standalone: false
})
export class BannerSecretariaTrabajoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
